import {
    isArray,
    isString,
    isFunction
} from "./main";
import {
    deepClone,
    deepChangedData
} from "./obj";
import {
    currencyToNumber
} from "./processRow";
//
// !! \THROW/ WARNING !!
// sorts: [{key: 1}, {KEY2: -1}]
// default str sort
export function multiSort(arr, sorts, comparatorByKey) {

    let keys = []; let key;
    let vectors = {}; let vector;

    sorts.forEach(function(row) {
        for (let key in row) {
            vector = row[key];

            if ( vector !== 1 && vector !== -1 ) {
                throw new Error("bad sort vector");
            }

            vectors[key] = vector;
            keys.push(key);
            break;
        }
    });

    //  сортировка по числу отличается от сортировки по строке
    let comparator_str = function(key, a, b) {
        return a[key] == b[key] ? 0
            : a[key] > b[key] ? vectors[key] : -vectors[key];
    };

    let comparator_number = function(key, a, b) {
        return +a[key] == +b[key] ? 0
            : +a[key] > +b[key] ? vectors[key] : -vectors[key];
    };

    let comparator_currency = function(key, a, b) {
        a = currencyToNumber(a[key]);
        b = currencyToNumber(b[key]);

        return +a == +b ? 0
            : +a > +b ? vectors[key] : -vectors[key];
    };

    // пользовательские компораторы (сортировки по столбцу)
    if ( !comparatorByKey ) {
        comparatorByKey = {};
    } else {
        comparatorByKey = deepClone(comparatorByKey);
        for (key in comparatorByKey) {
            if ( isString(comparatorByKey[key]) ) {
                if ( comparatorByKey[key] == "number" ) {
                    comparatorByKey[key] = comparator_number;
                }
                else if ( comparatorByKey[key] == "currency" ) {
                    comparatorByKey[key] = comparator_currency;
                }

                if ( !isFunction(comparatorByKey[key]) ) {
                    delete comparatorByKey[key];
                }
            }
        }
    }

    let n = keys.length;
    return arr.sort(function(a, b) {
        let res;
        for (let i = 0; i < n; i++) {
            if ( comparatorByKey[keys[i]] ) {
                res = comparatorByKey[keys[i]](keys[i], a, b);
            } else {
                res = comparator_str(keys[i], a, b);
            }

            if ( res !== 0 ) {
                return res;
            }
        }
        return 0;
    });
}

export function multiSortModels(models, sorts, comparatorByKey) {
    // костыльно, зато эффективно
    let rows = models.map(function(model) {
        model.attributes.____model____ = model;
        return model.attributes;
    });

    rows = multiSort(rows, sorts, comparatorByKey);
    return rows.map(function(row) {
        let model = row.____model____;
        delete row.____model____;
        return model;
    });
}

export function createChangesStack(lastArr, newArr) {
    let i; let n; let j; let m; let row; let newRow; let lastRow; let changes; let id; let lastId;
    let changesStack = [];

    if ( newArr.length === 0 ) {
        for (i = 0, n = lastArr.length; i < n; i++) {
            id = lastArr[i].id || lastArr[i]._id || lastArr[i].ID;
            if ( !id ) {
                continue;
            }

            changesStack.push({
                type: "remove",
                id,
                row: lastArr[i]
            });
        }
        return changesStack;
    }

    if ( lastArr.length === 0 ) {
        for (i = 0, n = newArr.length; i < n; i++) {
            row = newArr[i];
            id = row.id || row._id || row.ID;

            if ( id ) {
                changes = deepClone(row);
                delete changes.id;

                changesStack.push({
                    type: "update",
                    id,
                    changes,
                    row: newArr[i]
                });
            } else {
                changesStack.push({
                    type: "create",
                    row: newArr[i]
                });
            }

        }

        return changesStack;
    }

    for (i = 0, n = newArr.length; i < n; i++) {
        newRow = newArr[i];
        id = newRow.id || newRow._id || newRow.ID;

        if ( !id ) {
            changesStack.push({
                type: "create",
                row: newRow
            });
            continue;
        }

        changes = false;
        for (j = 0, m = lastArr.length; j < m; j++) {
            lastRow = lastArr[j];
            lastId = lastRow._id || lastRow.ID || lastRow.id;

            if ( lastId == id ) {
                changes = deepChangedData(lastRow, newRow);
            }
        }

        if ( changes ) {
            changesStack.push({
                type: "update",
                id,
                changes,
                row: newRow
            });
        }
    }

    return changesStack;
}

// объеденение массивов
export function arrayMerge(a, b) {
    let c = b.slice();

    for (let i = 0, n = a.length; i < n; i++) {
        if ( b.indexOf(a[i]) == -1 ) {
            c.push(a[i]);
        }
    }

    return c;
}

/**
 * Удаляет повторы из массива и возвращает новую копию
 * СТРОГОЕ сравнение элементов!
 * @param {array} arr исходный массив
 * @returns {array}
 */
export function removeRepeat(arr) {
    let newArr = [];
    for (let i = 0, n = arr.length; i < n; i++) {
        if ( newArr.indexOf(arr[i]) == -1 ) {
            newArr.push(arr[i]);
        }
    }
    return newArr;
}

function isVirtualId(id) {
    return !id || /^virtual/.test(id);
}

// на входе получаем 2 массива строк
// на выходе получаем 3 массива:
// массив строк на добавление
// массив строк на удаление
// массив строк на ищменение
export function mathChanges(last, current) {
    if ( !isArray(last) ) {
        last = [];
    }

    if ( !isArray(current) ) {
        current = [];
    }

    let changes = {
        update: [],
        remove: [],
        create: []
    };

    // сравниваем состояние строк
    function eq(current, last) {
        let key;
        for (key in current) {
            if ( !(key in last) || current[key] != last[key] ) {
                return false;
            }
        }

        for (key in last) {
            if ( !(key in current) || current[key] != last[key] ) {
                return false;
            }
        }

        return true;
    }

    // сначало найдем строки, которые необходимо удалить
    // а это все строки, которых нет в current, но есть в last
    // и эти строки имеют "настоящий" id (начинается не с virtual-id)
    let id; let toRemove; let i; let j; let n; let m;
    for (i = 0, n = last.length; i < n; i++) {
        id = last[i]._id;
        if ( isVirtualId(id) ) {
            continue;
        }

        toRemove = true;
        for (j = 0, m = current.length; j < m; j++) {
            if ( current[j]._id != id ) {
                continue;
            }

            toRemove = false;
            break;
        }

        if ( toRemove ) {
            changes.remove.push(last[i]);
        }
    }

    // поиск по current:
    // теперь найдем те строки, которые имеют виртуальный id
    // их отправим на добавления, а те кто имеют настоящий id
    // сравним с предыдущим состоянием, и если состояние изменилось,
    // то отправим их на update
    let row; let toUpdate;
    for (i = 0, n = current.length; i < n; i++) {
        row = current[i];
        if ( isVirtualId(row._id) ) {
            changes.create.push(row);
            continue;
        }

        toUpdate = true;
        for (j = 0, m = last.length; j < m; j++) {
            if ( last[j]._id != row._id ) {
                continue;
            }

            if ( eq(row, last[j]) ) {
                toUpdate = false;
                break;
            }
        }

        if ( toUpdate ) {
            changes.update.push(row);
        }
    }

    return changes;
}

export function area2matrix(area) {
    return area.models.map(function(model) {
        return area.fields.map(function(field) {
            let value = model.getText(field);

            // Дарья Курила (незнаю что):
            // можно попросить в значениях ячеек изменить точку на запятую ( цифры)
            // при копировании  в exl точки
            //  приходится исправлять, чтобы суммировать
            if ( value != null && model.storage && model.storage.columns ) {
                let column = model.storage.columns.getByKey(field);
                if (
                    column && column.get("type") == "number"
                        || column.get("type") == "currency"
                ) {
                    value += "";
                    value = value.replace(".", ",");
                    value = value.replace(/\s/g, "");
                }
            }

            return value;
        });
    });
}

// переводы строк
// https://github.com/epeli/underscore.string/blob/master/lines.js
// http://xpoint.ru/cgi-bin/perldoc.cgi?pod=perlport
// существует 3 формата переноса строк
// Windows: CRLF
// Linux:   LF
// Mac:     CR
function getEOL() {
    const CR = "\r";
    const LF = "\n";

    // default windows style (most popular)
    let eol = `${CR}${LF}`;

    // navigator.platform ~= MacIntel
    let isMac = (
        /iphone|ipad/i.test(navigator.platform)
            || /iphone|ipad/i.test(navigator.userAgent)
            || /mac/i.test(navigator.platform)
    );

    // navigator.platform ~= Linux x86_64
    let isLinux = (
        /linux/i.test(navigator.platform)
    );

    if ( isLinux ) {
        eol = LF;
    }

    if ( isMac ) {
        eol = CR;
    }

    return eol;
}

const eol = getEOL();


export function matrix2csv(matrix) {
    return matrix.map(function(texts) {
        return texts.join("\t");
    }).join(eol);
}

export function area2csv(area) {
    return area.models.map(function(model) {
        return area.fields.map(function(field) {
            return model.getText(field);
        }).join("\t");
    }).join(eol);
}

export function area2html(area) {
    let html = "<table border='0'><tbody>";

    area.models.map(function(model) {
        html += "<tr>";

        area.fields.map(function(field) {
            html += "<td>";
            html += model.getText(field) || "&nbsp;";
            html += "</td>";
        });

        html += "</tr>";
    });

    html += "</tbody></table>";

    return html;
}

export function matrix2html(matrix) {
    let html = "<table border='0'><tbody>";

    matrix.map(function(texts) {
        html += "<tr>";

        texts.map(function(text) {
            html += "<td>";
            html += text || "&nbsp;";
            html += "</td>";
        });

        html += "</tr>";
    });

    html += "</tbody></table>";

    return html;
}

export function csv2arr(csv) {
    if ( !csv || typeof csv != "string" )
    {return [];}

    let arr = [];
    csv = csv.split(/\n/);
    csv.forEach(function(row) {
        arr.push(row.split("\t").map(function(str) {
            return str && str.trim() || null;
        }));
    });

    return arr;
}

export function isArrOf(check, arr) {
    return isArray(arr) && arr.every(check);
}
